import axios from 'axios';
import { API_CONFIG } from './config';

export interface Redirect {
  id: string;
  input: string;
  output: string;
}

export const redirectsApi = {
  async getRedirectByInput(input: string): Promise<Redirect | null> {
    try {
      const response = await axios.get<Redirect>(`${API_CONFIG.BASE_URL}/redirects/byInput/${input}`);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  async getAllRedirects(): Promise<Redirect[]> {
    const response = await axios.get<Redirect[]>(`${API_CONFIG.BASE_URL}/redirects`);
    return response.data;
  }
};